<div class="w-100  h-100 d-flex flex-column spinner-item"
  [class.selected] = "spinnerValue > 0">
  <div class="d-flex flex-row justify-content-start align-items-center" *ngIf="included">
    <div class="included-label h7">{{'b2c.IDS_INCLUDED' | translate}}</div>
  </div>
  <div class="d-flex flex-row justify-content-between">
    <div class="d-flex flex-row justify-content-center align-items-center text-spinner">
      <span
        *ngIf="image"
        class="d-flex justify-content-center flex-column image-container">
        <img [src]="image" class="m-w-image h-100"/>
      </span>
      <span
        *ngIf="imageClassFromFrontEnd"
        class="card-icon bticino-ico {{imageClassFromFrontEnd}}">
      </span>
        <!-- <span class="bticino-ico {{imageClassFromFrontEnd}}"></span> -->
      <div class="d-flex flex-column spinner-text-column">
        <span class="d-inline-block m-b-variabile font-bticino-bold">{{title | translate}}</span>
        <span class="d-inline-block m-b-variabile font-tooltip" *ngIf="showTooltip">{{tooltip | translate}}</span>
        <span class="d-inline-block m-b-variabile font-price" *ngIf="showPrice">{{price | currency:'EUR':'symbol':'1.2-2':'it'}} {{'b2c.IDS_VAT_EXCLUDED' | translate}}</span>
        <!-- <button
          mat-button
          color="accent"
          *ngIf="showInfoButton"
          (click)="onInfoClick($event)">
          {{'b2c.IDS_DISCOVER_PRODUCT' | translate}}
        </button> -->
        <div class="info-button">
          <span *ngIf="showInfoButton"
          (click)="onInfoClick($event)"
          class = "d-flex font-price mat-button mat-accent">
          {{'b2c.IDS_DISCOVER_PRODUCT' | translate}}</span>
        </div>
      </div>
    </div>    
    <div class="spinner-1st-buttons d-flex justify-content-between align-items-center">
      <button
          mat-flat-button
          class="bticino-ico minus round-button-with-background"
          [class.disabled] = "spinnerValue == 0 || spinnerMin == spinnerMax || spinnerValue == spinnerMin"
          (click)="onRemove()"
        >
      </button>
      <span class="p-x-counter font-bticino-bold">{{ spinnerValue }}</span>
      <button
          mat-flat-button
          class="bticino-ico plus round-button-with-background"
          [class.disabled] = "spinnerMin == spinnerMax || spinnerValue == spinnerMax"
          (click)="onAdd()"
        >
      </button>
    </div>
  </div>

  <div class="spinner-2nd-row d-flex flex-row justify-content-between align-items-center">    
    <div>
      <span *ngIf="showInfoButton"
      (click)="onInfoClick($event)"
      color="accent"
      class = "d-flex font-price mat-button mat-accent">
      {{'b2c.IDS_DISCOVER_PRODUCT' | translate}}</span>
    </div>
    <div class="d-flex justify-content-between align-items-center plus">
      <button
          mat-flat-button
          class="bticino-ico minus round-button-with-background"
          [class.disabled] = "spinnerValue == 0 || spinnerMin == spinnerMax || spinnerValue == spinnerMin"
          (click)="onRemove()"
        >
      </button>
      <span class="p-x-counter font-bticino-bold">{{ spinnerValue }}</span>
      <button
          mat-flat-button
          class="bticino-ico plus round-button-with-background"
          [class.disabled] = "spinnerMin == spinnerMax || spinnerValue == spinnerMax"
          (click)="onAdd()"
        >
      </button>
    </div>
  </div>
</div>
